import { render, staticRenderFns } from "./Parcial.vue?vue&type=template&id=74c76b9a&"
import script from "./Parcial.vue?vue&type=script&lang=js&"
export * from "./Parcial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports